import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c19a88fe&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c19a88fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19a88fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c19a88fe')) {
      api.createRecord('c19a88fe', component.options)
    } else {
      api.reload('c19a88fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c19a88fe&scoped=true&", function () {
      api.rerender('c19a88fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Pagination/index.vue"
export default component.exports